import React from 'react'
import './Leftbar.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBicycle, faDollarSign, faGears, faUser} from '@fortawesome/free-solid-svg-icons'
import { faChartPie} from '@fortawesome/free-solid-svg-icons'
import { faLineChart} from '@fortawesome/free-solid-svg-icons'
import { faClipboardCheck} from '@fortawesome/free-solid-svg-icons'
import { faThLarge} from '@fortawesome/free-solid-svg-icons'
import { faTruck} from '@fortawesome/free-solid-svg-icons'
import { faArrowRightFromBracket} from '@fortawesome/free-solid-svg-icons'
import { faFaceSmile} from '@fortawesome/free-solid-svg-icons'
import { faTag} from '@fortawesome/free-solid-svg-icons'
import { faMoneyCheck} from '@fortawesome/free-solid-svg-icons'
import { faFaceAngry} from '@fortawesome/free-solid-svg-icons'
import { faBagShopping} from '@fortawesome/free-solid-svg-icons'
import { faUsers} from '@fortawesome/free-solid-svg-icons'
import { faPenNib} from '@fortawesome/free-solid-svg-icons'
import { faMugHot} from '@fortawesome/free-solid-svg-icons'
import { faChartSimple} from '@fortawesome/free-solid-svg-icons'
import { faClipboard} from '@fortawesome/free-solid-svg-icons'
import { faBriefcase} from '@fortawesome/free-solid-svg-icons'
import { faAddressCard} from '@fortawesome/free-solid-svg-icons'

//routers
import {useNavigate } from "react-router-dom";
import {Link } from "react-router-dom";
import Logo from '../Images/logowhite.svg'
import {NavLink } from "react-router-dom";


import {app} from '../firebase.js'
import { getAuth, signOut } from "firebase/auth";





function LeftBar() {

    let navigate = useNavigate();


    function logoutUser(){
        const auth = getAuth();
        signOut(auth).then(() => {
        // Sign-out successful.
            navigate("/login")  
        }).catch((error) => {

        });
    }



  return (
    <div className='leftbar'>

        <div className='logocontainer'>
            <img src={Logo} alt=""  className='logo'/>
        </div>

        <div className='menuContainer'>
            
            <div className='leftLinkCont d-flex align-items-center' >
                <NavLink to="/dashboard" className='leftNavLinks ' >
                    <FontAwesomeIcon icon={faThLarge} className="laftNavIcon"/>
                    Dashboard
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/vehicles" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faTruck} className="laftNavIcon"/>
                    Vehicles
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/drivers" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faUser} className="laftNavIcon"/>
                    Drivers
                </NavLink>
            </div>

            <hr />
            <p>LOGISTICS</p>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/clients" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faAddressCard} className="laftNavIcon"/>
                    Clients
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/orders" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faClipboardCheck} className="laftNavIcon"/>
                    Orders
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/trips" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faBicycle} className="laftNavIcon"/>
                    Trips
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/invoices" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faLineChart} className="laftNavIcon"/>
                    Send Invoices
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/manual-invoices" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faLineChart} className="laftNavIcon"/>
                    Manual Invoices
                </NavLink>
            </div>


            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/record-payments" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faDollarSign} className="laftNavIcon"/>
                    Record Payments
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/feedback" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faMoneyCheck} className="laftNavIcon"/>
                    Feedback
                </NavLink>
            </div>

            <div className='leftLinkCont d-flex align-items-center'>
                <NavLink to="/price-settings" className='leftNavLinks '>
                    <FontAwesomeIcon icon={faGears} className="laftNavIcon"/>
                    Settings
                </NavLink>
            </div>


            <hr />
            <div className='logoutMenu' onClick={logoutUser}>
                <div className='leftLinkCont d-flex align-items-center'>
                    <div  className='leftNavLinks logoutbtn'>
                        <FontAwesomeIcon icon={faArrowRightFromBracket} className="laftNavIcon"/>
                        Logout
                    </div>
                </div>
            </div>

        

        </div>




    
    </div>
  )
}

export default LeftBar
